import { z } from "zod";
import { BaseEvent } from "./base";
import { Actor } from "./shared/actor";
const VersionDate = z.object({
    type: z.literal("date"),
    version: z.string()
});
const VersionSHA = z.object({
    type: z.literal("sha"),
    sha: z.string()
});
const Version = z.discriminatedUnion("type", [
    VersionDate,
    VersionSHA
]);
const DeploymentEvent = z.object({
    // Some ID that tracks the deployments for a group by
    deployment_id: z.string(),
    srv: z.string(),
    env: z.string(),
    chn: z.string().optional(),
    version: z.array(Version).default([]),
    // Where can I access this thing?
    administration_url: z.string().optional(),
    deployed_url: z.string().optional(),
    // Who did this?
    actor: Actor.optional()
});
export const Deployment_Start = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Deployment_Start"),
    event: DeploymentEvent
});
export const Deployment_Complete = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Deployment_Complete"),
    event: DeploymentEvent
});
export const Deployment_Fail = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Deployment_Fail"),
    event: DeploymentEvent.extend({
        // What issue happened
        failure_message: z.string().optional()
    })
});
export const Deployment_Boot = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Deployment_Boot"),
    event: z.object({
        srv: z.string(),
        env: z.string(),
        chn: z.string().optional(),
        version: z.array(Version).default([]),
        hostname: z.string().optional()
    })
});
